import FormattedMessage from 'I18n/components/FormattedMessage';
import { Select } from 'foundations-components/transitional/components/Select';
import { getUISelectDateFormatOptions as getUISelectDateFormatOptionsUtil } from 'forms-utils-lib/date/getUISelectDateFormatOptions';
import { FormControl as DefaultFormControl } from 'foundations-components/transitional/components/FormControl';
import { jsx as _jsx } from "react/jsx-runtime";
const DateFormatPicker = ({
  onChange = () => {},
  getUISelectDateFormatOptions = getUISelectDateFormatOptionsUtil,
  value = '',
  labelKey = '',
  tooltipKey = '',
  FormControl = DefaultFormControl,
  optionSeparatorTypesKey = ''
}) => /*#__PURE__*/_jsx(FormControl, {
  label: /*#__PURE__*/_jsx(FormattedMessage, {
    message: labelKey
  }),
  tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
    message: tooltipKey
  }),
  tooltipPlacement: "top right",
  "data-test-id": "date-format-picker",
  children: /*#__PURE__*/_jsx(Select, {
    onChange: onChange,
    options: getUISelectDateFormatOptions(textKey => /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${optionSeparatorTypesKey}.${textKey}`
    })),
    value: value,
    searchable: false,
    "data-test-id": "date-format-picker-select"
  })
});
export default DateFormatPicker;